import { CdkDragDrop, CdkDragEnd, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-calendar',
  standalone: false,
  templateUrl: './calendar.component.html',
  styleUrl: './calendar.component.scss'
})
export class CalendarComponent implements OnInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
 @Input() phase:any
  fullscreen = false;
  steps: any[] = [];
  allWeeks: any[] = [];
  weekOffset = 0;
  visibleWeekCount = 8;
  totalWeeks = 0;
  firstStepDate!: Date;
  lastStepDate!: Date;
  colorPalette = ['#4285F4', '#EA4335', '#FBBC05', '#34A853', '#673AB7', '#FF5722', '#009688'];
  weekWidth = 120;
  proposalId: number; 
  today: Date = new Date();

  constructor(private api: ApiService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const proposalId = params['id'];
      this.proposalId = proposalId
       const phaseId = params['phase']
      this.phase = phaseId
      if (proposalId) {
        this.loadSteps();  // Fetch full proposal from backend
      }
    });

    // this.loadSteps();
  }
  @Output() stepsLoaded = new EventEmitter<any[]>();
  loadSteps() {
    //     this.steps = [
    //   {
    //     id: 1,
    //     name: "Proposal Received",
    //     created_on: "2025-07-01T00:00:00Z",
    //     week_timeline: 2,
    //     step_status: "2", // Approved (green)
    //     is_approved: true
    //   },
    //   {
    //     id: 2,
    //     name: "Initial Review",
    //     created_on: "2025-07-15T00:00:00Z",
    //     week_timeline: 1,
    //     step_status: "1", // In Progress (yellow)
    //     is_approved: false
    //   },
    //   {
    //     id: 3,
    //     name: "Technical Assessment",
    //     created_on: "2025-07-10T00:00:00Z",
    //     week_timeline: 1, // Overdue (red - created 11 days ago)
    //     step_status: "0", 
    //     is_approved: false
    //   },
    //   {
    //     id: 4,
    //     name: "Client Meeting",
    //     created_on: "2025-07-18T00:00:00Z",
    //     week_timeline: 1,
    //     step_status: "1", // In Progress (yellow)
    //     is_approved: false
    //   },
    //   {
    //     id: 5,
    //     name: "Final Approval",
    //     created_on: "2025-07-20T00:00:00Z", 
    //     week_timeline: 3,
    //     step_status: "0", // Initiation Pending (yellow)
    //     is_approved: false
    //   },
    //   {
    //     id: 6,
    //     name: "Contract Signed",
    //     created_on: "2025-07-05T00:00:00Z",
    //     week_timeline: 1,
    //     step_status: "2", // Approved (green)
    //     is_approved: true
    //   },
    //   {
    //     id: 7,
    //     name: "Project Kickoff",
    //     created_on: "2025-07-25T00:00:00Z",
    //     week_timeline: 2,
    //     step_status: "3", // Rejected (red)
    //     is_approved: false
    //   }
    // ];
    this.api.getAPI(`/transaction/proposals/${this.proposalId}/details/?phase_id=${this.phase}`).subscribe((res: any) => {
      // this.steps = res.data;
       const allSteps = res.data;
    this.steps = allSteps.filter((step: any) => !step.skipped);
      this.stepsLoaded.emit(res);

      // Sort steps by created date
      this.steps.sort((a, b) => new Date(a.created_on).getTime() - new Date(b.created_on).getTime());

      // Calculate total timeline
      this.totalWeeks = this.steps.reduce((sum, step) => sum + step.week_timeline, 0);

      // Set date range
      this.firstStepDate = new Date(this.steps[0].created_on);
      const totalWeeks = this.steps.reduce((sum, step) => sum + step.week_timeline, 0);

      // Add total days to the start date
      this.lastStepDate = this.addDays(new Date(this.firstStepDate), totalWeeks * 7);

      // Generate weeks after data is loaded
      this.generateAllWeeks();
    }, (error) => {
      console.error('Error loading steps:', error);
      // Handle error appropriately
    });
  }

  generateAllWeeks() {
    this.allWeeks = [];
    let currentDate = new Date(this.firstStepDate);

    for (let i = 0; i < this.totalWeeks; i++) {
      const startDate = this.getStartOfWeek(new Date(currentDate));
      const endDate = this.getEndOfWeek(new Date(currentDate));

      this.allWeeks.push({
        weekNumber: i + 1,
        startDate: startDate,
        endDate: endDate
      });

      currentDate = this.addDays(endDate, 1);
    }
  }

  // Synchronized scrolling
  syncScroll(event: Event) {
    const container = event.target as HTMLElement;
    const scrollTop = container.scrollTop;

    const scrollables = container.querySelectorAll('.steps-list, .steps-content-scrollable');
    scrollables.forEach(el => {
      if (Math.abs(el.scrollTop - scrollTop) > 1) {
        el.scrollTop = scrollTop;
      }
    });
  }

  // Horizontal scrolling
  // scrollHorizontal(weeks: number) {
  //   this.weekOffset = Math.max(0, this.weekOffset + weeks);
  //   this.weekOffset = Math.min(this.weekOffset, this.totalWeeks - this.visibleWeekCount);
  // }

  get visibleStartWeek(): number {
    return this.weekOffset + 1;
  }

  get visibleEndWeek(): number {
    return Math.min(this.weekOffset + this.visibleWeekCount, this.totalWeeks);
  }

  // Step positioning methods
  getStepLeftOffset(step: any): number {
    const stepIndex = this.steps.indexOf(step);
    let weeksBefore = 0;
    for (let i = 0; i < stepIndex; i++) {
      weeksBefore += this.steps[i].week_timeline;
    }
    return weeksBefore * this.weekWidth - (this.weekOffset * this.weekWidth);
  }

  getStepWidth(step: any): number {
    return step.week_timeline * this.weekWidth;
  }

  isStepActiveInWeek(step: any, week: any): boolean {
    const stepIndex = this.steps.indexOf(step);
    const weekIndex = this.allWeeks.indexOf(week);

    let weeksBefore = 0;
    for (let i = 0; i < stepIndex; i++) {
      weeksBefore += this.steps[i].week_timeline;
    }

    return weekIndex >= weeksBefore && weekIndex < weeksBefore + step.week_timeline;
  }

  // getWeekCellsContainerWidth(): string {
  //   return (this.totalWeeks * this.weekWidth) + 'px';
  // }

  // Add this method to your component class
  getStepEndDate(step: any): Date {
    return this.addDays(new Date(step.created_on), step.week_timeline * 7);
  }

  // And modify the formatShortDate method to handle Date objects
  formatShortDate(date: Date | string): string {
    if (!date) return '';

    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return `${dateObj.getDate()}/${dateObj.getMonth() + 1}/${dateObj.getFullYear().toString().slice(-2)}`;
  }

  addDays(date: Date, days?: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  formatLongDate(date: Date | undefined): string {
    if (!date) return '';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  getStartOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setDate(diff));
  }

  getEndOfWeek(date: Date): Date {
    const start = this.getStartOfWeek(new Date(date));
    return this.addDays(start, 6);
  }

  // addDays(date: Date, days: number): Date {
  //   const result = new Date(date);
  //   result.setDate(result.getDate() + days);
  //   return result;
  // }

  isCurrentWeek(week: any): boolean {
    const today = new Date();
    return today >= week.startDate && today <= week.endDate;
  }

  getStepColor(index: number): string {
    return this.colorPalette[index % this.colorPalette.length];
  }

  getStepTopOffset(index: number): number {
    return index * 60 + 5;
  }
  @ViewChild('weekHeader') weekHeader!: ElementRef;
  @ViewChild('timelineScroll') timelineScroll!: ElementRef;

  // weekWidth = 120;
  stepListWidth = 200;

  onTimelineScroll() {
    const scrollLeft = this.timelineScroll.nativeElement.scrollLeft;
    this.weekHeader.nativeElement.scrollLeft = scrollLeft;
  }

  // Calculate timeline total width
  getWeekCellsContainerWidth(): string {
    return `${this.totalWeeks * this.weekWidth}px`;
  }

  // Total scrollable width = step list + timeline
  getWeekCellsContainerWidthWithStepList(): string {
    return `${this.totalWeeks * this.weekWidth + this.stepListWidth}px`;
  }

  // Prevent overscrolling by disabling right nav button
  scrollHorizontal(weeks: number) {
    const maxOffset = Math.max(0, this.totalWeeks - this.visibleWeekCount);
    this.weekOffset = Math.min(maxOffset, Math.max(0, this.weekOffset + weeks));
  }
  // Add this method to your component class
  getStepStatusStyle(step: any) {
    // Check if step is approved
    if (step.step_status == 'approved') { // Assuming '2' is approved status
      return {
        'background-color': '#34A853', // Green for approved
        'color': 'white'
      };
    }

    // Check if timeline has exceeded
    const today = new Date();
    const stepEndDate = this.addDays(new Date(step.created_on), step.week_timeline * 7);

    if (today > stepEndDate) {
      return {
        'background-color': '#EA4335', // Red for overdue
        'color': 'white'
      };
    }

    // Default/yellow for pending
    return {
      'background-color': '#FBBC05', // Yellow for pending
      'color': 'black'
    };
  }

  getStepStatusText(step: any) {
    switch (step.step_status) {
      case '0':
        return 'Initiation Pending';
      case '1':
        return 'In Progress';
      case '2':
        return 'Approved';
      case '3':
        return 'Rejected';
      default:
        return 'Status: ' + step.step_status;
    }
  } 
  // Add to your component
hoveredStep: string | null = null;

setHoverStep(stepId: string | null): void {
  this.hoveredStep = stepId;
}
}